import React from "react";
import styled from "styled-components";
import Loader from "../../Components/Loader";
import NormalText from "../../Components/NormalText";
import Helmet from "react-helmet";
import Avatar from "../../Components/Avatar";
import { media } from "../../styles/Mixin";
import { Link } from 'react-router-dom';
import MakeCategory from "../../Components/MakeCategory";
import CategoryBox from "../../Components/CategoryBox";

export default ({
  data,
  loading,
  createCategoryWindow,
  setCreateCategoryWindow,
  channelId,
  ctgData,
  ctgLoading,
  history
}) => {
  if (loading || ctgLoading) {
    return (
      <>
        <Helmet>
          <title>로딩중..</title>
        </Helmet>
        <Loader />
      </>
    );
  } else if (data.seeUser === null) {
    return (
      <Wrapper>
        <Helmet>
          <title>존재하지 않는 채널</title>
        </Helmet>
        <NoUser>
          <NormalText text={"채널이 존재하지 않습니다 😅"} />
        </NoUser>
      </Wrapper>
    );
  }
  return (
    <Wrapper>
      <Helmet>
        <title>{data.seeUser.displayName} 님 채널</title>
      </Helmet>
      <BixBox>
        <GuidBox>
          <GuidNameText text={"'" + data.seeUser.displayName + "'"} />
          <GuidText text={"님의 채널에 오신걸 환영합니다!"}></GuidText>
          <AvatarBox>
            <Avatar size={"l_md"} url={data.seeUser.profileImageUrl} />
          </AvatarBox>
        </GuidBox>
        {data.seeUser.isSelf && (
          <AddContentsBox>
            <AddCategoryBox>
              <NormalText text={"+ 카테고리 만들기"} onClick={() => { setCreateCategoryWindow(true)}} />
            </AddCategoryBox>
            <QustionAnswerBox>
              <NormalText text={"+ 질문 & 답 추가"} onClick={() => { history.push("/")}} />
            </QustionAnswerBox>
          </AddContentsBox>
        )}
        <SeeCategoryBox>
          {ctgData.seeCategories.map((category,i) => (
            <EachCategoryBox key={i} to={`/${channelId}/${category.id}`}>
              <CategoryBox categoryName={category.categoryName} categoryCount={category.categoryCount}/>
            </EachCategoryBox>
          ))}
        </SeeCategoryBox>
        {
          createCategoryWindow === true && (
            <MakeCategory 
              setCreateCategoryWindow={setCreateCategoryWindow}
              channelId={channelId}
            />

          )
        }
      </BixBox>
    </Wrapper>
  );
};


const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top:50px;
  width: 100%;
`;

const NoUser = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const BixBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;

const GuidBox = styled.div`
  display: flex;
  position:relative;
  align-items: center;
  justify-content:center;
  
  ${media.deskTop`
    padding:10px;
    min-width: 70%;
    max-width: 70%;
    `}
    ${media.mobile`
    padding:2px;
    width: 80%;
    `}
    margin-bottom:30px;
    background-color: ${(props) => props.theme.blueColor};
    border-radius: 100px 100px 100px 100px;
`;
const GuidNameText = styled(NormalText)`
  font-weight: bold;
  ${media.deskTop`
    margin-left:50px;
    `}
`;

const GuidText = styled(NormalText)`
  color: ${(props) => props.theme.grey};
`;

const AvatarBox = styled.div`
  position: absolute;
  left: 0;
`;

const AddContentsBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-weight: bold;
  margin-bottom: 30px;
`;

const AddCategoryBox = styled.div`
  margin-right: 20px;
  cursor: pointer;
`;

const QustionAnswerBox = styled.div`
  /* display: flex; */
  /* flex-direction: row;
  justify-content: center; */
  margin-left: 20px;
  cursor: pointer;
`;

const MobileGuidtext = styled(NormalText)`
  ${media.deskTop`
    display:none;
    `}
  cursor:pointer;
`;

const SeeCategoryBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items:center;
  width:100%;
  &>:not(:last-child){
    margin-bottom:30px;
  }
`;

const EachCategoryBox = styled(Link)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width:100%;
  text-decoration: none;
  color:inherit;
`;
